import { useState } from "react";

import Button from "../../components/Button/Button";
import InputText from "../../components/InputText/InputText";
import LabelSelect from "../../components/LabelSelect/LabelSelect";
import { GUEST, USER } from "../../constans/roles";
import Header from "../Header/Header";
import { submitRegisterForm } from "./registerController";
import "../Login/Login.css";
import "./Register.css";

const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(GUEST);

  const handleRegister = async (event) => {
    event.preventDefault();
    await submitRegisterForm({ email, password, role });
  };

  return (
    <>
      <Header />
      <div className="register-wrapper register-wrapper--register">
        <form className="register-form register-form--register" onSubmit={handleRegister}>
          <InputText
            placeholder="Login"
            value={email}
            text="Login: "
            name="mail"
            handleChange={(event) => setEmail(event.target.value)}
          />

          <InputText
            placeholder="haslo"
            value={password}
            text="Haslo: "
            name="haslo"
            handleChange={(event) => setPassword(event.target.value)}
          />

          <LabelSelect
            options={[
              { value: GUEST, txt: "Gosc" },
              { value: USER, txt: "Grafik" },
            ]}
            text="Rola: "
            name="role"
            handleChange={(event) => setRole(event.target.value)}
          />

          <Button
            txt="Dodaj"
            click={handleRegister}
            styles={{
              width: "300px !important",
              margin: "0",
              backgroundColor: "black",
            }}
          />
        </form>

        <section className="register-right-section register-right-section--register">
          <img src="./Images/logo_white.png" alt="Balans Agency" className="register-right-section__logo" />
        </section>
      </div>
    </>
  );
};

export default Register;
